import { useAppBridge } from "@shopify/app-bridge-react";

let setLang = "ja";
export const tInitialize = (lang: string) => {
  setLang = lang;
};
export const t = (ja: string, en: string) => {
  return setLang === "ja" ? ja : en;
};

export const getParse = (obj: {}) => JSON.parse(JSON.stringify(obj));

export const shopifyFecth = async (props: {
  query: string;
  variables?: any;
}) => {
  const { query, variables } = props;
  const url = "shopify:admin/api/graphql.json";
  const res = await fetch(url, {
    method: "POST",
    body: JSON.stringify(
      variables
        ? {
            query,
            variables,
          }
        : { query }
    ),
  });

  const { data, errors } = await res.json();
  errors && console.log(errors);
  return data;
};
